import SecondaryButtonDefaultProps from "segments/desktop/core-components/button/secondary-button/default-props";
import SignupButtonDefaultProps from "segments/desktop/core-components/button/signup-button/default-props";

export default {
  signupButtonConfig: SignupButtonDefaultProps,
  secondaryButtonConfig: { ...SecondaryButtonDefaultProps, buttonText: "Learn more" }
};
